import React, { useState } from 'react';
import { Input } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { addReturnedMaterial, removeReturnedMaterial } from '../../helperFunctions';

export default props => {
  const { material, smallerFontSize } = props;
  const dispatch = useDispatch();
  const returnedMaterials = useSelector(state => state.tasks.returnedMaterials);

  const [quantityValue, setQuantityValue] = useState(null);

  return (
    <Input
      style={{ marginBottom: '0px', padding: '0px' }}
      inputProps={{
        style: { fontSize: smallerFontSize },
        min: 0,
        max: material.quantity,
      }}
      size="small"
      margin="none"
      type="number"
      value={quantityValue}
      onChange={y => {
        const value =
          Number(y.target.value) < material.quantity ? Number(y.target.value) : material.quantity;
        if (value !== 0) {
          setQuantityValue(value);
          addReturnedMaterial(value, material, returnedMaterials, dispatch);
        } else {
          setQuantityValue(null);
          removeReturnedMaterial(material, returnedMaterials, dispatch);
        }
      }}
    />
  );
};
